import Input from '@vvg/forum/vue/components/form/input.vue'
import Asset from '@vvg/forum/vue/components/form/asset.vue'
import Textarea	 from '@vvg/forum/vue/components/form/textarea.vue'
import CkEditor	 from '@vvg/forum/vue/components/form/ck-editor.vue'

export default {
	components: {
		Input,
		Asset,
		Textarea,
		CkEditor,
	},
}